import { Routes } from '@angular/router';
import { DashboardComponent } from 'src/core/components/dashboard/dashboard.component';

export const dashboardRoutes: Routes = [
  {
    path: '',
    component: DashboardComponent,
    title: 'dashboard',
  },
];
